/*
 * @Author:
 * @LastEditTime: 2022-04-18 14:50:56
 * @Description: 后台管理
 */
export default [
  {
    id: '8941e309-5318-48ab-a1b7-ae5239ad3dd3434',
    name: 'contractor-management',
    path: '/contractor-management-sm',
    meta: { title: '承包商管理' },
    children: [
      {
        id: 'd533b490-1546-4868-8552-812fcae74c8b',
        path: 'guideline-configuration',
        name: 'guideline-gonfiguration',
        component(resolve) {
          require(['./views/ContractorGuidelineConfiguration'], resolve)
        },
        meta: {
          title: '承包商资质材料配置',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            createType: {
              id: 4,
              name: 'createType',
              desc: '新增类型',
              access: true,
            },
            updateType: {
              id: 5,
              name: 'updateType',
              desc: '修改类型',
              access: true,
            },
            deleteType: {
              id: 6,
              name: 'deleteType',
              desc: '删除类型',
              access: true,
            },
          },
        },
      },
      {
        id: '1d3dbc67-37d3-4480-b438-f80a0d59240c',
        path: 'template',
        name: 'template',
        component(resolve) {
          require(['./views/ContractorTemplate'], resolve)
        },
        meta: {
          title: '承包商资质模板引用',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: 'faed5caa-9d28-4282-867b-610795b32969',
        path: 'unit-files',
        name: 'unit-files',
        component(resolve) {
          require(['./views/UnitFiles'], resolve)
        },
        meta: {
          title: '承包商单位档案',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '查看',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            readFlow: {
              id: 3,
              name: 'readFlow',
              desc: '查看流程',
              access: true,
              group: 'read',
            },
            addBlack: {
              id: 4,
              name: 'addBlack',
              desc: '加入黑名单',
              access: true,
            },
            removeBlack: {
              id: 5,
              name: 'removeBlack',
              desc: '移除黑名单',
              access: true,
            },
            createAccount: {
              id: 6,
              name: 'createAccount',
              desc: '创建账号',
              access: true,
            },
          },
        },
      },
      {
        id: '631ddbdd-f7cb-460b-88ec-0fb5b5dab312',
        path: 'start-permission',
        name: 'start-permission',
        component(resolve) {
          require(['./views/ContractorStartPermission'], resolve)
        },
        meta: {
          title: '承包商开工许可',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            submit: {
              id: 4,
              name: 'submit',
              desc: '提交',
              access: true,
            },
            audit: {
              id: 5,
              name: 'audit',
              desc: '审批',
              access: true,
            },
            readFlow: {
              id: 6,
              name: 'readFlow',
              desc: '查看流程',
              access: true,
              group: 'read',
            },
          },
        },
      },
      {
        id: 'f0668c5f-ec60-4593-8b65-cc6f65d258b0',
        path: 'personnel-configuration',
        name: 'personnel-configuration',
        component(resolve) {
          require(['./views/ContractorPersonnelEnter'], resolve)
        },
        meta: {
          title: '承包商人员入厂',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            readFlow: {
              id: 4,
              name: 'readFlow',
              desc: '查看流程',
              access: true,
              group: 'read',
            },
            import: {
              id: 5,
              name: 'import',
              desc: '导入',
              access: true,
            },
            submit: {
              id: 6,
              name: 'submit',
              desc: '提交',
              access: true,
            },
            audit: {
              id: 7,
              name: 'audit',
              desc: '审批',
              access: true,
            },
            resetFactory: {
              id: 8,
              name: 'resetFactory',
              desc: '返厂',
              access: true,
            },
            // TODO:暂时注释，以便后面需要
            // createAccount: {
            //   id: 8,
            //   name: 'createAccount',
            //   desc: '批量创建账号',
            //   access: true,
            // },
          },
        },
      },
      {
        id: 'f794dd93-9af1-4031-9b0d-68da5a2a7ddc',
        path: 'person-files',
        name: 'person-files',
        component(resolve) {
          require(['./views/PersonFiles'], resolve)
        },
        meta: {
          title: '承包商人员档案',
          keepAlive: false,
          operations: {
            read: {
              id: 0,
              name: 'read',
              desc: '查看',
              access: true,
              group: 'read',
            },
            readFlow: {
              id: 1,
              name: 'readFlow',
              desc: '查看流程',
              access: true,
              group: 'read',
            },
            addBlack: {
              id: 2,
              name: 'addBlack',
              desc: '加入黑名单',
              access: true,
            },
            removeBlack: {
              id: 3,
              name: 'removeBlack',
              desc: '移除黑名单',
              access: true,
            },
            changeProject: {
              id: 4,
              name: 'changeProject',
              desc: '变更项目',
              access: true,
            },
          },
        },
      },
      {
        id: '4dd6bd0e-6aec-48a8-9399-ce779ded7dec',
        path: 'unit-leave',
        name: 'unit-leave',
        component(resolve) {
          require(['./views/ContractorUnitLeave'], resolve)
        },
        meta: {
          title: '承包商单位退厂',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            read: {
              id: 2,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            readFlow: {
              id: 4,
              name: 'readFlow',
              desc: '查看流程',
              access: true,
              group: 'read',
            },
            leave: {
              id: 5,
              name: 'leave',
              desc: '退厂',
              access: true,
            },
            historyRecord: {
              id: 6,
              name: 'historyRecord',
              desc: '出入厂历史记录',
              access: true,
            },
            submit: {
              id: 7,
              name: 'submit',
              desc: '提交',
              access: true,
            },
            audit: {
              id: 8,
              name: 'audit',
              desc: '审批',
              access: true,
            },
          },
        },
      },
      {
        id: '8cd8e3c6-ebf9-4f4e-aed5-f93a6f721d28',
        path: 'personnel-leave',
        name: 'personnel-leave',
        component(resolve) {
          require(['./views/ContractorPersonnelLeave'], resolve)
        },
        meta: {
          title: '承包商人员退厂',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            read: {
              id: 2,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            flow: {
              id: 4,
              name: 'flow',
              desc: '查看流程',
              access: true,
            },
            leave: {
              id: 5,
              name: 'leave',
              desc: '退厂',
              access: true,
            },
            history: {
              id: 6,
              name: 'history',
              desc: '出入厂记录',
              access: true,
            },
            submit: {
              id: 7,
              name: 'submit',
              desc: '提交',
              access: true,
            },
            audit: {
              id: 8,
              name: 'audit',
              desc: '审批',
              access: true,
            },
          },
        },
      },
      {
        id: '5c629d6f-e166-4c92-8143-bd88ad782a0b',
        path: 'special-ledger',
        name: 'special-ledger',
        component(resolve) {
          require(['./views/SpecialPersonnelLedger'], resolve)
        },
        meta: {
          title: '特种作业人员台账',
          keepAlive: false,
          operations: {
            detail: {
              id: 0,
              name: 'read',
              desc: '查看',
              access: true,
              group: 'read',
            },
            delete: {
              id: 1,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: 'de88a071-8c19-4bb9-9046-85e73fcb2481',
        path: 'one-book-one-team',
        name: 'one-book-one-team',
        component(resolve) {
          require(['./views/OneBookOneTeam'], resolve)
        },
        meta: {
          title: '承包商一队一册',
          keepAlive: false,
          operations: {
            read: {
              id: 1,
              name: 'read',
              desc: '查看',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
          },
        },
      },
      {
        id: '38c2cf0b-7d12-4c3e-8d55-627ef0200294',
        path: 'one-book-one-team/info',
        name: 'book-team-info',
        component(resolve) {
          require(['./components/one-book-one-team/index'], resolve)
        },
        meta: {
          title: '承包商一队一册',
          keepAlive: false,
          tabnab: false,
          hidden: true,
          activeMenu: '/contractor-management/one-book-one-team',
        },
      },
      {
        id: 'c15ed660-19ef-4c1c-a078-f16cb73f4014',
        path: 'short-term-contractor',
        name: 'shortTermContractor',
        component(resolve) {
          require(['./views/ShortTermContractor'], resolve)
        },
        meta: {
          title: '短期承包商',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '查看',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            submit: {
              id: 4,
              name: 'submit',
              desc: '提交',
              access: true,
            },
            audit: {
              id: 5,
              name: 'audit',
              desc: '审批',
              access: true,
            },
            readFlow: {
              id: 6,
              name: 'readFlow',
              desc: '查看流程',
              access: true,
              group: 'read',
            },
            addBlack: {
              id: 7,
              name: 'addBlack',
              desc: '加入黑名单',
              access: true,
            },
            removeBlack: {
              id: 8,
              name: 'removeBlack',
              desc: '移除黑名单',
              access: true,
            },
            withdraw: {
              id: 9,
              name: 'withdraw',
              desc: '撤回',
              access: true,
            },
            delay: {
              id: 10,
              name: 'delay',
              desc: '延期',
              access: true,
            },
          },
        },
      },
      {
        id: '6bb560a7-7e67-4498-ad87-829440b4470e',
        path: 'short-term-contractor-detail',
        name: 'shortTermContractorDetail',
        component: () => {
          return import('./views/ShortTermContractorDetail')
        },
        meta: {
          title: '短期承包商详情',
          hidden: true,
          tabnab: false,
          activeMenu: '/contractor-management/short-term-contractor',
        },
      },
      {
        id: '3fa4ada6-ef25-4668-8e30-ccd21e6a100b',
        path: 'short-term-contractor-person',
        name: 'shortTermContractorPerson',
        component: () => {
          return import('./views/ShortTermContractorPerson')
        },
        meta: {
          title: '短期承包商人员详情',
          hidden: true,
          tabnab: false,
          activeMenu: '/contractor-management/short-term-contractor',
        },
      },
    ],
  },
]
